import { atom } from 'recoil'
import getConfig from '../utilities/config'

const tenant = atom({
  key: 'tenant',
  default: getConfig()?.user?.tenants?.[0],
})

export default tenant
